export default "__VITE_ASSET__EQPUypod__"